module.exports = __webpack_public_path__ + "static/media/laura.f712642d.jpg";